<div class="modal-body m-0 m-lg-3" style="z-index: 9999;">
    <div class="mb-4">
        <h1 ngbAutofocus translate="Request.View.Withdrawn.RequestWithdrawn"></h1>
    </div>
    <div class="row row-cols-12 default-font-size">
        <app-action-summary [actions]="actions" [documents]="documents"
            [requestStatus]="requestStatus"></app-action-summary>
    </div>
    <div class="alert alert-danger p-2 break-words default-font-size white-space" role="alert">
        <span>{{withdrawReason}}</span>
    </div>
    <app-redirect-countdown TranslationKeyForNoCountdown="Request.View.Withdrawn.MayCloseTab">
    </app-redirect-countdown>
</div>